import React from 'react';

class DataDeliveryLogs extends React.Component {

  componentWillMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }

  render() {
    return (
      <div>
        Logs
      </div>
    );
  }
}

export default DataDeliveryLogs;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/DataDeliveryLogs.js